import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../axios";

const NAV_ITEMS = [
  {
    to: "/",
    label: "Dashboard",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    to: "/contacts",
    label: "Contacts",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    to: "/campaign",
    label: "Campaign",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
      </svg>
    ),
  },
  {
    to: "/history",
    label: "History",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <polyline points="12 8 12 12 14 14" />
        <path d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" />
      </svg>
    ),
  },
  {
    to: "/analytics",
    label: "Analytics",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
        <line x1="2" y1="20" x2="22" y2="20" />
      </svg>
    ),
  },
  { to: "/templates", label: "Templates", icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/>
    </svg>
  )},
  { to: "/profile", label: "My Profile", icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8"/>
    </svg>
  )},
];

const CONDITIONAL_ITEMS = {
  ai_chatbot: {
    to: "/bot-settings",
    label: "AI Chatbot",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        <circle cx="12" cy="17" r="1" fill="currentColor" />
      </svg>
    ),
  },
  inbox: {
    to: "/inbox",
    label: "WhatsApp Inbox",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  meta_inbox: {
    to: "/meta-inbox",
    label: "Meta Inbox",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </svg>
    ),
  },
  followup: {
    to: "/followup-sequences",
    label: "Follow-up Sequences",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <polyline points="17 1 21 5 17 9" />
        <path d="M3 11V9a4 4 0 0 1 4-4h14" />
        <polyline points="7 23 3 19 7 15" />
        <path d="M21 13v2a4 4 0 0 1-4 4H3" />
      </svg>
    ),
  },
  ai_ads: {
    to: "/ai-ads",
    label: "AI Ads Planner",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <path d="M12 2l2.2 6.8H21l-5.5 4 2.1 6.8L12 15.4 6.4 19.6l2.1-6.8L3 8.8h6.8L12 2z" />
      </svg>
    ),
  },
  products: {
    to: "/products",
    label: "Products & Services",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <path d="M20.5 7.3 12 2 3.5 7.3v9.4L12 22l8.5-5.3z" />
        <path d="M3.5 7.3 12 12l8.5-4.7M12 22V12" />
      </svg>
    ),
  },
  orders: {
    to: "/orders",
    label: "Orders",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
        <path d="M3 6h18M16 10a4 4 0 0 1-8 0" />
      </svg>
    ),
  },
  poster: {
    to: "/poster-planner",
    label: "AI Poster Planner",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="M21 15l-5-5L5 21" />
      </svg>
    ),
  },
  admin: {
    to: "/admin/users",
    label: "Admin Panel",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.07 4.93l-1.41 1.41M4.93 4.93l1.41 1.41M4.93 19.07l1.41-1.41M19.07 19.07l-1.41-1.41M12 2v2M12 20v2M2 12h2M20 12h2" />
      </svg>
    ),
  },
};

function NavLink({ to, label, icon, onClick }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <li>
      <Link
        to={to}
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "9px 12px",
          borderRadius: "8px",
          fontSize: "13.5px",
          fontWeight: isActive ? "600" : "400",
          letterSpacing: "0.01em",
          color: isActive ? "#ffffff" : "rgba(255,255,255,0.55)",
          background: isActive
            ? "linear-gradient(135deg, rgba(99,102,241,0.35) 0%, rgba(168,85,247,0.2) 100%)"
            : "transparent",
          borderLeft: isActive ? "2px solid #818cf8" : "2px solid transparent",
          textDecoration: "none",
          transition: "all 0.18s ease",
          position: "relative",
          marginLeft: "-2px",
        }}
        onMouseEnter={(e) => {
          if (!isActive) {
            e.currentTarget.style.color = "rgba(255,255,255,0.9)";
            e.currentTarget.style.background = "rgba(255,255,255,0.06)";
          }
        }}
        onMouseLeave={(e) => {
          if (!isActive) {
            e.currentTarget.style.color = "rgba(255,255,255,0.55)";
            e.currentTarget.style.background = "transparent";
          }
        }}
      >
        <span style={{ opacity: isActive ? 1 : 0.75 }}>{icon}</span>
        {label}
      </Link>
    </li>
  );
}

function HamburgerIcon({ isOpen }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: "20px", height: "20px" }}>
      {isOpen ? (
        <>
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </>
      ) : (
        <>
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </>
      )}
    </svg>
  );
}

export default function Sidebar() {
  const role = localStorage.getItem("role");
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showInstall, setShowInstall] = useState(false);

  const [permissions, setPermissions] = useState({
    can_use_inbox: 0,
    can_use_ai_chatbot: 0,
    can_use_ai_ads: 0,
    can_use_products: 0,
    can_use_orders: 0,
    can_use_poster: 0,
    has_meta_settings: 0,
  });

  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const checkInstallAvailable = () => {
      setShowInstall(Boolean(window.crmInstallAvailable));
    };

    checkInstallAvailable();

    const timer = setInterval(checkInstallAvailable, 1000);
    window.addEventListener("appinstalled", checkInstallAvailable);

    return () => {
      clearInterval(timer);
      window.removeEventListener("appinstalled", checkInstallAvailable);
    };
  }, []);

  useEffect(() => {
    if (isMobile) setIsOpen(false);
  }, [location.pathname, isMobile]);

  useEffect(() => {
    const loadPermissions = async () => {
      try {
        const res = await api.get("/auth/me");

        setPermissions({
          can_use_inbox: Number(res.data.can_use_inbox || 0),
          can_use_ai_chatbot: Number(res.data.can_use_ai_chatbot || 0),
          can_use_ai_ads: Number(res.data.can_use_ai_ads || 0),
          can_use_products: Number(res.data.can_use_products || 0),
          can_use_orders: Number(res.data.can_use_orders || 0),
          can_use_poster: Number(res.data.can_use_poster || 0),
          has_meta_settings: Number(res.data.has_meta_settings || 0),
        });
      } catch (err) {
        console.log(err);
      }
    };

    loadPermissions();
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  const isAdmin = role === "admin";
  const canInbox = isAdmin || permissions.can_use_inbox === 1;
  const canAI = isAdmin || permissions.can_use_ai_chatbot === 1;
  const canAiAds = isAdmin || permissions.can_use_ai_ads === 1;
  const canProducts = isAdmin || permissions.can_use_products === 1;
  const canOrders = isAdmin || permissions.can_use_orders === 1;
  const canPoster = isAdmin || permissions.can_use_poster === 1;
  const canMetaInbox =
    isAdmin || (canInbox && Number(permissions.has_meta_settings || 0) === 1);

  const sidebarContent = (
    <div
      style={{
        width: "240px",
        display: "flex",
        flexDirection: "column",
        padding: "24px 16px",
        background: "linear-gradient(180deg, #0f1117 0%, #111827 100%)",
        borderRight: "1px solid rgba(255,255,255,0.07)",
        boxSizing: "border-box",
        fontFamily: "'DM Sans', 'Inter', system-ui, sans-serif",
        height: "100vh",
        maxHeight: "100vh",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "32px",
            padding: "4px 12px 4px 10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "8px",
                background: "linear-gradient(135deg, #6366f1, #a855f7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
              </svg>
            </div>

            <span
              style={{
                fontSize: "15px",
                fontWeight: "700",
                color: "#fff",
                letterSpacing: "-0.02em",
              }}
            >
              VisionBot
            </span>
          </div>

          {isMobile && (
            <button
              onClick={() => setIsOpen(false)}
              style={{
                background: "rgba(255,255,255,0.07)",
                border: "none",
                borderRadius: "6px",
                color: "rgba(255,255,255,0.6)",
                cursor: "pointer",
                padding: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ×
            </button>
          )}
        </div>

        <p style={{ fontSize: "10.5px", fontWeight: "600", color: "rgba(255,255,255,0.25)", letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 8px 14px" }}>
          Main Menu
        </p>

        <ul style={{ listStyle: "none", margin: "0 0 20px 0", padding: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} {...item} onClick={isMobile ? () => setIsOpen(false) : undefined} />
          ))}
        </ul>

        {(canAI || canInbox || canAiAds || canProducts || canOrders || canPoster || isAdmin) && (
          <>
            <div style={{ height: "1px", background: "rgba(255,255,255,0.07)", margin: "4px 0 16px" }} />

            <p style={{ fontSize: "10.5px", fontWeight: "600", color: "rgba(255,255,255,0.25)", letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 8px 14px" }}>
              Features
            </p>

            <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
              {canAI && (
                <NavLink {...CONDITIONAL_ITEMS.ai_chatbot} onClick={isMobile ? () => setIsOpen(false) : undefined} />
              )}

              {canInbox && (
                <NavLink {...CONDITIONAL_ITEMS.inbox} onClick={isMobile ? () => setIsOpen(false) : undefined} />
              )}

              {canMetaInbox && (
                <NavLink {...CONDITIONAL_ITEMS.meta_inbox} onClick={isMobile ? () => setIsOpen(false) : undefined} />
              )}

              {canInbox && (
                <NavLink {...CONDITIONAL_ITEMS.followup} onClick={isMobile ? () => setIsOpen(false) : undefined} />
              )}

              {canAiAds && (
                <NavLink {...CONDITIONAL_ITEMS.ai_ads} onClick={isMobile ? () => setIsOpen(false) : undefined} />
              )}
              {canProducts && (
                <NavLink {...CONDITIONAL_ITEMS.products} onClick={isMobile ? () => setIsOpen(false) : undefined} />
              )}
              {canOrders && (
                <NavLink {...CONDITIONAL_ITEMS.orders} onClick={isMobile ? () => setIsOpen(false) : undefined} />
              )}
              {canPoster && (
                <NavLink {...CONDITIONAL_ITEMS.poster} onClick={isMobile ? () => setIsOpen(false) : undefined} />
              )}

              {isAdmin && (
                <>
                  <div style={{ height: "1px", background: "rgba(255,255,255,0.07)", margin: "6px 0 8px" }} />
                  <NavLink {...CONDITIONAL_ITEMS.admin} onClick={isMobile ? () => setIsOpen(false) : undefined} />
                </>
              )}
            </ul>
          </>
        )}
      </div>

      <div style={{ marginTop: "auto", paddingTop: "16px", borderTop: "1px solid rgba(255,255,255,0.07)", flexShrink: 0 }}>
        {showInstall && (
          <button
            onClick={() => window.installCRMApp?.()}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "9px 12px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #16a34a, #22c55e)",
              border: "none",
              color: "#ffffff",
              fontSize: "13.5px",
              fontWeight: "600",
              cursor: "pointer",
              letterSpacing: "0.01em",
              marginBottom: "8px",
              boxShadow: "0 4px 14px rgba(34,197,94,0.25)",
            }}
          >
            📲 Install CRM App
          </button>
        )}

        <button
          onClick={logout}
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "9px 12px",
            borderRadius: "8px",
            background: "transparent",
            border: "none",
            color: "rgba(255,100,100,0.7)",
            fontSize: "13.5px",
            fontWeight: "500",
            cursor: "pointer",
            letterSpacing: "0.01em",
            transition: "all 0.18s ease",
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );

  return (
    <>
      {!isMobile && (
        <div style={{ width: "240px", flexShrink: 0 }}>
          {sidebarContent}
        </div>
      )}

      {isMobile && (
        <button
          onClick={() => setIsOpen(true)}
          style={{
            position: "fixed",
            bottom: "80px",
            left: "14px",
            zIndex: 1100,
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #6366f1, #a855f7)",
            border: "none",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 14px rgba(99,102,241,0.45)",
          }}
          aria-label="Open menu"
        >
          <HamburgerIcon isOpen={false} />
        </button>
      )}

      {isMobile && isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1199,
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(2px)",
          }}
        />
      )}

      {isMobile && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1200,
            height: "100vh",
            maxHeight: "100vh",
            overflow: "hidden",
            transform: isOpen ? "translateX(0)" : "translateX(-100%)",
            transition: "transform 0.26s cubic-bezier(0.4,0,0.2,1)",
            boxShadow: isOpen ? "4px 0 30px rgba(0,0,0,0.4)" : "none",
          }}
        >
          {sidebarContent}
        </div>
      )}
    </>
  );
}